import { render, staticRenderFns } from "./DeleteWarning.vue?vue&type=template&id=66aa9d2a&"
import script from "./DeleteWarning.vue?vue&type=script&lang=ts&"
export * from "./DeleteWarning.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteWarning.vue?vue&type=style&index=0&id=66aa9d2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports